import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const customerorganizationApi = createApi({
  reducerPath: "customerorganizationApi",
  baseQuery,
  tagTypes: ["Organization"],
  endpoints: (builder) => ({

    // ----------------------------
    // 1) CREATE ORGANIZATION (POST)
    // ----------------------------
    createOrganization: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/customers`,
        method: "POST",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: {
          customerMaster:data,
        },
      }),
      invalidatesTags: ["Organization"],
    }),

    // ----------------------------
    // 2) UPDATE ORGANIZATION (PUT)
    // ----------------------------
    updateOrganization: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/customers/${id}`,
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: {customerMaster:data},
      }),

      invalidatesTags: ["Organization"],
    }),

    // ----------------------------
    // 3) GET ORGANIZATION BY ID (GET)
    // ----------------------------
    getOrganizationById: builder.query({
      query: (id) => `/customers/${id}`,

      transformResponse: (response) => {
        return response?.data || {};
      },

      providesTags: ["Organization"],
    }),

  }),
});

export const {
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
  useLazyGetOrganizationByIdQuery,
  // useDeleteOrganizationMutation,
} = customerorganizationApi;
